import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { NotificationManager } from "../../../../../../../components/Notifications";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  deleteInputList: []
};

const route = "modules/manage/modals/createEditManageTemperature/redux/slice";

export const manageDeleteManageInput = createAsyncThunk(
  "manage/deleteManageInput/deleteManageInput",
  async (payload, { rejectWithValue }) => {
    const mutations = [];
    try {
      const { items } = payload;
      if (items?.length) {
        items.forEach((item, index) => {
          mutations.push(`deleteInputLabel${index}: deleteInputLabel(id: ${item?.id})`);
        });
        const mutation = `mutation { ${mutations.join(" ")} }`;
        const data = await clientMutation(
          mutation, 
          {}, 
          endpoints.GRAPHQL_GENERAL
        );
        if (data?.deleteInputLabel0) return data.deleteInputLabel0;
        else throw "Error while deleting manage Input";
      }
    } catch (exc) {
      NotificationManager.error(
        "Error",
        `Error Deleting Manage Temperature`,
        3000,
        null,
        null,
        "error"
      );
      ExceptionManager(exc, route, "deleteInputLabel");
      rejectWithValue(exc);
    }
  }
);

const manageDeleteManageInputRedux = createSlice({
  name: "manage/deleteManageInput",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalDeleteManageInput(state, action) {
      state.open = true;
      state.deleteInputList = action?.payload?.deleteInputList;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    // manageDeleteManageInput
    builder.addCase(manageDeleteManageInput.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageDeleteManageInput.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(manageDeleteManageInput.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageInputRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteManageInput } = actions;

// Export the reducer, either as a default or named export
export default reducer;
